import React from "react";
import Loading from "../../Components/Loading";

export default function Authenticate() {
	
    return <div style={{height: "100vh"}}><Loading/></div>
}
